const SPEAKER_STYLES = {
  physician: {
    bg: 'bg-blue-50',
    border: 'border-l-blue-500',
    name: 'text-blue-700',
  },
  patient: {
    bg: 'bg-amber-50',
    border: 'border-l-amber-500',
    name: 'text-amber-700',
  },
  nurse: {
    bg: 'bg-teal-50',
    border: 'border-l-teal-500',
    name: 'text-teal-700',
  },
}

export default function DialogueTurn({ turn }) {
  const role = turn.speaker_role || turn.speaker || 'patient'
  const style = SPEAKER_STYLES[role] || SPEAKER_STYLES.patient
  const speakerName = turn.speaker_name || role

  return (
    <div className={`${style.bg} ${style.border} border-l-4 rounded-r-lg p-3`}>
      <span className={`font-semibold text-sm ${style.name}`}>
        {speakerName}
      </span>
      <p className="text-sm mt-1 leading-relaxed">{turn.content}</p>
    </div>
  )
}
